<template>
  <v-navigation-drawer v-model="drawer" floating right fixed temporary>
    <v-list>
      <!-- <v-list-item v-for="menu in menus" :key="menu.title" link>
        <v-list-item-title v-if="menu.children">
          {{ menu.title }}
        </v-list-item-title>
        <v-list-item-title v-else @click="goTo(menu.title)">
          {{ menu.title }}
        </v-list-item-title>
      </v-list-item> -->
      <span v-for="menu in menus" :key="menu.title">
        <v-list-item
          v-if="menu.children == null"
          link
          @click="goTo(menu.title)"
        >
          <v-list-item-title>{{ menu.title }}</v-list-item-title>
        </v-list-item>
        <v-list-group v-else color="rgb(153, 27, 30)">
          <template v-slot:activator>
            <v-list-item-title>{{ menu.title }}</v-list-item-title>
          </template>
          <v-list-item
            v-for="(child, i) in menu.children"
            :key="i"
            link
            @click="goTo(child.title)"
            class="submenu"
            dark
          >
            <v-list-item-title v-text="child.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider />
      </span>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { menus } from "../../utils/constants";

export default {
  data: () => ({
    menus: menus,
  }),
  computed: {
    drawer: {
      get() {
        return this.$store.state.showSidebar;
      },
      set(val) {
        this.$store.commit("sidebar", val);
      },
    },
  },
  methods: {
    goTo(name) {
      this.$router.push({ name }).catch(() => {});
      this.$store.commit("sidebar", false);
    },
  },
};
</script>

<style scoped lang="scss">
.submenu {
  background-color: rgb(153, 27, 30);
}
</style>